import './boostrap.scss'
import 'bootstrap/dist/js/bootstrap.bundle'
import './tailwind.css'
import Rails from '@rails/ujs'

Rails.start()